// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\DTO.tt
// </auto-generated>
// ------------------------------------------------------------------------------
/**
 * 账户初始化信息DTO DTO类
 * 账户初始化信息DTO
 */
export class InitInfoDTO {
  /** 工作空间名称 : 工作空间名称 */
  private _workScopeName: string;

  /** 设置：工作空间名称 */
  public get workScopeName() {
    return this._workScopeName;
  }

  /** 获取：工作空间名称 */
  public set workScopeName(value: string) {
    this._workScopeName = value;
  }

  /** 工作空间显示名称 : 工作空间显示名称 */
  private _workScopeDisplayName: string;

  /** 设置：工作空间显示名称 */
  public get workScopeDisplayName() {
    return this._workScopeDisplayName;
  }

  /** 获取：工作空间显示名称 */
  public set workScopeDisplayName(value: string) {
    this._workScopeDisplayName = value;
  }

  constructor() {
    this._workScopeName = '';
    this._workScopeDisplayName = '';
  }

  public toJson(): any {
    const json = {};
    this.Serialize(json);
    return json;
  }

  protected Deserialize(json: any): void {
    this.workScopeName = json.WorkScopeName;
    this.workScopeDisplayName = json.WorkScopeDisplayName;
  }

  protected Serialize(json: any): void {
    json.WorkScopeName = this.workScopeName;
    json.WorkScopeDisplayName = this.workScopeDisplayName;
  }

  static Create(json: any): InitInfoDTO {
    const initInfoDTO = new InitInfoDTO();
    initInfoDTO.Deserialize(json);
    return initInfoDTO;
  }
}
